// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '[PX][Try again using a complete date like this: ' + p['dateExample'] + '. éëžéëžéëžéëž]',
  chart_labelGroup: () => '[PX][Group é]',
  chart_labelSeries: () => '[PX][Series é]',
  chart_labelValue: () => '[PX][Value é]',
  checkboxSet_requiredMessageDetail: () => '[PX][Required é]',
  checkbox_requiredMessageDetail: () => '[PX][Required é]',
  close: () => '[PX][Close é]',
  collection_noData: () => '[PX][No data to display. é]',
  collection_selectAllRows: () => '[PX][Select all rows é]',
  collection_selectRow: (p: { ROW_NAME: string }) => '[PX][Select row ' + p['ROW_NAME'] + ' é]',
  collection_sortDisabled: () => '[PX][Not sortable é]',
  collection_sortEnabled: () => '[PX][Sortable é]',
  confirmation: () => '[PX][Confirmation é]',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    '[PX][' + p['itemCount'] + ' out of ' + p['totalCount'] + ' éëžé]',
  dataVisualization_noData: () => '[PX][No data to display é]',
  dataVisualization_stateSelected: () => '[PX][Selected é]',
  dataVisualization_stateUnselected: () => '[PX][Unselected é]',
  error: () => '[PX][Error é]',
  expandableList_expandCollapseInstructionText: () =>
    '[PX][Use arrow keys to expand and collapse éëžéëž]',
  expandableList_groupCollapse: () => '[PX][Collapsed é]',
  expandableList_groupExpand: () => '[PX][Expanded é]',
  filePicker_addFiles: () => '[PX][Add Files é]',
  filePicker_dropzonePrimaryText: () => '[PX][Drag and Drop é]',
  filePicker_dropzoneSecondaryText: () => '[PX][Select a file or drop one here éëžé]',
  filePicker_dropzoneSecondaryTextMultiple: () => '[PX][Select or drop files here éë]',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "[PX][You can't upload files of type: " + p['fileTypes'] + ' éëžéëžé]',
  filePicker_singleFileUploadError: () => '[PX][Upload one file at a time éë]',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "[PX][You can't upload files of type " + p['fileType'] + ' éëžéëžé]',
  filePicker_unknownFileTypeUploadError: () => '[PX][unknown é]',
  formControl_clear: () => '[PX][Clear é]',
  formControl_day: () => '[PX][Day é]',
  formControl_helpAvailable: () => '[PX][Help available é]',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    '[PX][You’ve reached the limit of ' +
    (({ one: '1 character' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('en-XA').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('en-XA').format(p['CHARACTER_LIMIT']) + ' characters') +
    '. éëžéëžéëžéëžéëžéëžéëžéë]',
  formControl_loading: () => '[PX][Loading é]',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '[PX][Maximum length ' + p['MAX_LENGTH'] + ' exceeded. éëžéëž]',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '[PX][' + p['CHARACTER_COUNT'] + ' characters left. éëžéë]',
  formControl_month: () => '[PX][Month é]',
  formControl_readOnly: () => '[PX][Read only é]',
  formControl_requiredMessageDetail: () => '[PX][Enter a value. é]',
  formControl_year: () => '[PX][Year é]',
  gantt_labelDate: () => '[PX][Date é]',
  gantt_labelEnd: () => '[PX][End é]',
  gantt_labelLabel: () => '[PX][Label é]',
  gantt_labelRow: () => '[PX][Row é]',
  gantt_labelStart: () => '[PX][Start é]',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    '[PX][' + p['SECTION'] + '. No matching section found. éëžéëž]',
  indexer_keyboardInstructionText: () => '[PX][Press enter to select value. éëž]',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '[PX][Between ' + p['FROM_SECTION'] + ' and ' + p['TO_SECTION'] + '. éëžéëžé]',
  indexer_touchInstructionText: () =>
    '[PX][Double tap and hold to enter gesture mode, then drag up or down to adjust value. éëžéëžéëžéëžéëžéëžé]',
  info: () => '[PX][Info é]',
  inputDateMask_date_cleared: () => '[PX][Date cleared é]',
  inputDateMask_dayPlaceholder: () => '[PX][dd é]',
  inputDateMask_empty_segment: () => '[PX][Empty é]',
  inputDateMask_monthPlaceholder: () => '[PX][mm é]',
  inputDateMask_yearPlaceholder: () => '[PX][yyyy é]',
  inputNumber_converterParseError: () => '[PX][Enter a number. é]',
  inputNumber_decrease: () => '[PX][Decrease é]',
  inputNumber_increase: () => '[PX][Increase é]',
  inputPassword_hidden: () => '[PX][Password Hidden é]',
  inputPassword_hide: () => '[PX][Hide Password é]',
  inputPassword_show: () => '[PX][Show Password é]',
  list_suggestion: () => '[PX][Suggestion é]',
  messageToast_allMessagesClosed: () => '[PX][All toast messages are closed. éëžé]',
  message_close: () => '[PX][Close é]',
  message_confirmation: () => '[PX][Success é]',
  message_error: () => '[PX][Error é]',
  message_info: () => '[PX][Info é]',
  message_navigationFromMessagesRegion: () =>
    '[PX][Entering messages region. Press F6 to navigate back to prior focused element. éëžéëžéëžéëžéëžéëž]',
  message_navigationToMessagesRegion: () =>
    '[PX][Messages region has new messages. Press F6 to navigate to the most recent message region. éëžéëžéëžéëžéëžéëžéëž]',
  message_warning: () => '[PX][Warning é]',
  noData_message: () => '[PX][No items to display é]',
  overflowItemLabel: () => '[PX][More Tabs é]',
  plural_separator: () => ', ',
  progressIndeterminate: () => '[PX][In Progress é]',
  radio_helpForRadio: () => '[PX][Help for radio button é]',
  radio_requiredMessageDetail: () => '[PX][Select a value. é]',
  selectMultiple_apply: () => '[PX][Apply é]',
  selectMultiple_back: () => '[PX][Back é]',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    '[PX][Press Backspace or Delete to remove the selected value. éëžéëžéëžéë]',
  selectMultiple_selectedValues: () => '[PX][Selected values é]',
  selectMultiple_showSelectedValues: () => '[PX][Show selected values only. éë]',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '[PX][' + p['VALUE_COUNT'] + ' values selected. éëžé]',
  select_addToList: () => '[PX][Add to list é]',
  select_addToListAvailable: () => '[PX][Add to list available é]',
  select_moreSearchOptions: () => '[PX][More search options é]',
  select_moreSearchOptionsAvailable: () => '[PX][More search options available éëž]',
  select_noMatchesFound: () => '[PX][No matches found. é]',
  select_oneMatchFound: () => '[PX][One match found é]',
  select_requiredMessageDetail: () => '[PX][Select a value. é]',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[PX][' + p['TOTAL_SIZE'] + ' matches found éë]',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[PX][' + p['TOTAL_SIZE'] + ' or more matches found éëžéë]',
  selector_selected: () => '[PX][Checkbox checked é]',
  selector_unselected: () => '[PX][Checkbox not checked é]',
  tabBarNavigationList_removeCueText: () => '[PX][Removable é]',
  timeComponent_tooltipZoomIn: () => '[PX][Zoom In é]',
  timeComponent_tooltipZoomOut: () => '[PX][Zoom Out é]',
  train_current: () => '[PX][Current é]',
  train_message_type: () => '[PX][Message Type é]',
  train_not_visited: () => '[PX][Not visited é]',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '[PX][Step ' + p['currentStep'] + ' out of ' + p['numberOfSteps'] + ' éëžéëžé]',
  train_visited: () => '[PX][Visited é]',
  userAssistance_learnMore: () => '[PX][Learn more é]',
  userAssistance_required: () => '[PX][Required é]',
  viz_drillable: () => '[PX][Drillable é]',
  warn: () => '[PX][Warning é]'
};
export default bundle;
